import reduceReducer from 'reduce-reducers';
import { combineReducers } from 'redux';
import { requestsReducer } from 'redux-requests';

import asyncReducer from './asyncReducer';
import file from './file';
import syncReducer from './syncReducer';

export default combineReducers({
  domain: reduceReducer(asyncReducer, syncReducer),
  requests: requestsReducer,
  files: file,
});
